import { api } from "..";
import { AppSettingKey, AppSettingsAll } from "./types";

export interface UpdateAppSettingParams<K extends AppSettingKey> {
  key: K;
  value: AppSettingsAll[K];
}

export async function updateAppSetting<K extends AppSettingKey>(
  params: UpdateAppSettingParams<K>
): Promise<{ key: K; value: AppSettingsAll[K] }> {
  const res = await api.client.put(`/app-settings/${params.key}`, {
    value: params.value,
  });
  return res.data;
}
